import React from "react";
import { motion } from "framer-motion";

const serviciosData = [
  {
    titulo: "Consulta Oftalmológica",
    imagen: "/images/consulta-oftalmologica.jpg",
    descripcion: "Evaluación completa por un especialista en oftalmología.",
  },
  {
    titulo: "Consulta Optométrica",
    imagen: "/images/consulta-optometrica.jpg",
    descripcion: "Revisión visual para diagnóstico y corrección.",
  },
  {
    titulo: "Cirugías",
    imagen: "/images/cirugias.jpg",
    descripcion: "Procedimientos quirúrgicos con tecnología avanzada.",
  },
  {
    titulo: "Óptica",
    imagen: "/images/optica.jpg",
    descripcion: "Lentes, armazones y soluciones de visión.",
  },
  {
    titulo: "bleafaroplastia",
    imagen: "/images/blefaroplastia.jpg",
    descripcion: "Cirugía estética y funcional de párpados.",
  },
  {
    titulo: "Campimetría",
    imagen: "/images/campimetria.jpg",
    descripcion: "Estudio del campo visual para detección temprana.",
  },
  {
    titulo: "Topografía",
    imagen: "/images/topografia.jpg",
    descripcion: "Mapa detallado de la córnea para diagnóstico preciso.",
  },
  {
    titulo: "IPL",
    imagen: "/images/ipl.jpg",
    descripcion: "Tratamiento avanzado para ojo seco y otras patologías.",
  },
];

// Animaciones
const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const cardAnim = {
  hidden: { opacity: 0, y: 30 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: "easeOut" },
  },
};

export default function Servicios({ titulo }) {
  return (
    <section id="servicios" className="py-16 bg-gray-50">
      <h2 className="text-3xl font-bold text-center text-blue-900 mb-10">
        {titulo}
      </h2>

      <motion.div
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.2 }}
        className="max-w-6xl mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-6 px-6"
      >
        {serviciosData.map((srv, i) => (
          <motion.div
            key={i}
            variants={cardAnim}
            whileHover={{ scale: 1.03, boxShadow: "0px 8px 20px rgba(0,0,0,0.15)" }}
            className="p-4 rounded-2xl border bg-white shadow-sm cursor-pointer"
          >
            <img
              src={srv.imagen}
              alt={srv.titulo}
              className="w-full h-40 object-cover rounded-xl"
            />
            <h3 className="font-semibold text-blue-900 mt-4">{srv.titulo}</h3>
            <p className="text-sm text-gray-600 mt-1">{srv.descripcion}</p>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
